import { ActionTypes } from "../constants/action-types";

export const setTaskSchedules = (taskSchedules) => {
	return {
		type: ActionTypes.SET_TASKS_SCHEDULES,
		payload: taskSchedules,
	};
};
